import _ from 'underscore';

app.WayfinderView = app.AccordionFieldView.extend({
  className() {
    return `${app.AccordionFieldView.prototype.className.apply(this)} alert-rules-panel`;
  },

  initialize(options) {
    _.extend(options || {}, {
      newValue() {
        return {};
      },
      // Provide the method for determining the title of the cell.
      getTitle(fieldGroupView) {
        const fields = fieldGroupView.getValue();

        return fields.name || '';
      },
      templateData: {
        title: 'Wayfinder Floors',
        buttonText: 'new wayfinder floor',
        emptyText: 'no wayfinder floors yet',
      },
    });

    app.AccordionFieldView.prototype.initialize.apply(this, arguments);
  },
});
